import { render, staticRenderFns } from "./FAQSeal.vue?vue&type=template&id=6ea4ec7a&scoped=true"
import script from "./FAQSeal.vue?vue&type=script&lang=js"
export * from "./FAQSeal.vue?vue&type=script&lang=js"
import style0 from "./FAQSeal.vue?vue&type=style&index=0&id=6ea4ec7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4ec7a",
  null
  
)

export default component.exports